module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./SpecialSortActivityView.js"));
	}, "SpecialSortActivityView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SpecialSortActivityView!./src/pages/Shop/Home/SpecialSortActivity/SpecialSortActivityView.js
// module id = 1842
// module chunks = 367